<template>
    <div :class="titleContainerClass">
        <div class="flex-grow">
            <h1 :class="titleClass"><slot></slot></h1>
        </div>
        <div>
            <slot name="button">
                <template v-if="buttonText && buttonLink">
                    <router-link :to="buttonLink" :class="buttonClass" v-if="isRoute">{{ buttonText }}</router-link>
                    <a :href="buttonLink" :class="buttonClass" @click="$emit('button-clicked')" v-else>{{ buttonText }}</a>
                </template>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            titleContainerClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.title_container;
                }
            },
            titleClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.title;
                }
            },
            buttonText: {
                type: String,
            },
            buttonLink: {
                //
            },
            buttonClass: {
                type: String,
                default() {
                    return this.$spa.css.button.default;
                }
            }
        },
        computed: {
            isRoute() {
                return typeof this.buttonLink == 'object';
            }
        }
    }
</script>
